module.exports = ".add-account-button-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n}"